import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useStorage } from 'contexts';

type SearchContext = {
	saveQuery: any;
	onClick: any;
};

export const SearchContext = React.createContext<SearchContext>(null);

const SearchProvider = ({ children }) => {
	const router = useRouter();
	const storage = useStorage();

	// Hooks
	useEffect(() => {}, []);

	// Methods
	const saveQuery = (modelName, query, result) => {
		try {
			const modelId = result?.id;
			const formattedQuery = query.toLowerCase();
			const search = storage.getValue('search');
			const formattedSearch = search
				.slice(0, 10)
				.filter(hit => hit.modelName === modelName || hit.query === formattedQuery);
			const formattedRecord = { modelId, modelName, query: formattedQuery, result, date: new Date() };
			storage.storeValue('search', formattedSearch.concat(formattedRecord));
		} catch (e) {
			console.error(e);
		}
	};

	const onClick = result => {
		saveQuery('docs', result.title, result);
		if (result.category) return router.push(`/${result.category}/${result.uuid}`);
		return router.push(`/${result.uuid}`);
	};

	// Render
	return <SearchContext.Provider value={{ saveQuery, onClick }}>{children}</SearchContext.Provider>;
};

const useSearch = () => {
	return React.useContext(SearchContext);
};

export { SearchProvider, useSearch };
